(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(25179);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hookform_error_message__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32866);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);








var Textarea = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var mainClassName = _param.mainClassName, name = _param.name, label = _param.label, errors = _param.errors, touched = _param.touched, required = _param.required, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "mainClassName",
        "name",
        "label",
        "errors",
        "touched",
        "required"
    ]);
    var inputRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return inputRef.current;
    });
    var hasError = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(errors, name) && (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2)(touched, name);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: mainClassName !== null && mainClassName !== void 0 ? mainClassName : "",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-0 w-full text-base-regular",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        name: name,
                        placeholder: " ",
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("pt-4 pb-1 block w-full px-4 mt-0 bg-transparent border appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200", {
                            "border-rose-500 focus:border-rose-500": hasError
                        })
                    }, props), {
                        ref: inputRef
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        htmlFor: name,
                        onClick: function() {
                            var _$ref;
                            return (_$ref = inputRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
                        },
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("mx-3 px-1 transition-all absolute duration-300 top-3 -z-1 origin-0 text-gray-500", {
                            "!text-rose-500": hasError
                        }),
                        children: [
                            label,
                            required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-rose-500",
                                children: "*"
                            })
                        ]
                    })
                ]
            }),
            hasError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hookform_error_message__WEBPACK_IMPORTED_MODULE_7__/* .ErrorMessage */ .B, {
                errors: errors,
                name: name,
                render: function(param) {
                    var message = param.message;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-1 pl-2 text-rose-500 text-xsmall-regular",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: message
                        })
                    });
                }
            })
        ]
    });
});
Textarea.displayName = "Textarea";
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 16767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _modules_common_icons_arrow_right__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37233);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);




var UnderlineLink = function(param) {
    var href = param.href, children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex justify-center small:justify-start items-start",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: href,
            prefetch: false,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex items-center text-large-regular border-b border-darkTone gap-x-4 py-2 transition-all duration-300 group hover:text-highlight hover:pl-4 hover:pr-1", className !== null && className !== void 0 ? className : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "font-mono",
                        children: children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_common_icons_arrow_right__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        size: 20,
                        className: "transition-all group-hover:ml-2 duration-300"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UnderlineLink);


/***/ }),

/***/ 25179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/common/components/head/index.tsx
var head = __webpack_require__(63269);
// EXTERNAL MODULE: ./src/modules/layout/templates/index.tsx + 13 modules
var templates = __webpack_require__(77092);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/modules/common/components/input/index.tsx + 2 modules
var input = __webpack_require__(1166);
// EXTERNAL MODULE: ./src/modules/common/components/button/index.tsx
var components_button = __webpack_require__(77391);
// EXTERNAL MODULE: ./src/modules/common/components/textarea/index.tsx
var components_textarea = __webpack_require__(52095);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(17590);
// EXTERNAL MODULE: ./src/modules/common/components/underline-link/index.tsx
var underline_link = __webpack_require__(16767);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/lib/util/loader.ts
var loader = __webpack_require__(44269);
;// CONCATENATED MODULE: ./src/modules/common/components/contact-element/index.tsx





var ContactElement = function(param) {
    var image = param.image, alt = param.alt, caption = param.caption, title = param.title, subtitle = param.subtitle, content = param.content, cta = param.cta, _entranceAnimation = param.entranceAnimation, entranceAnimation = _entranceAnimation === void 0 ? false : _entranceAnimation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("w-full text-neutral-900", "grid grid-cols-1 small:grid-cols-3 gap-0", {
                "bg-white grain-background": entranceAnimation
            }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "z-10 pt-10 small:pt-0 flex flex-col justify-center text-center md:text-left px-10 md:p-32 gap-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-2xl md:text-3xl lg:text-4xl 2xl:text-5xl font-display font-base subpixel-antialiased",
                            children: title !== null && title !== void 0 ? title : ""
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)(underline_link/* default */.Z, {
                            className: "uppercase",
                            href: cta.url,
                            children: cta.text
                        }),
                        content !== null && content !== void 0 ? content : ""
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "z-10 pt-[5vh] pr-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative aspect-[2/1] small:aspect-[9/10] w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute z-10 text-white ml-10 mt-10 font-semibold text-lg",
                                children: caption !== null && caption !== void 0 ? caption : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Design &",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " Duurzaam"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                loader: loader/* ImageLoader */.S,
                                src: image,
                                layout: "fill",
                                loading: "eager",
                                objectFit: "cover",
                                quality: 90,
                                priority: true,
                                alt: alt !== null && alt !== void 0 ? alt : "Welcome to AKU Panel",
                                className: "",
                                draggable: "false",
                                sizes: "(max-width: 400px) 100vw, (max-width: 800px) 100vw, 33vw",
                                placeholder: typeof image === "string" ? "empty" : "blur"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("z-10 flex flex-col content-start justify-center pl-2 gap-8 pt-10 small:pt-[12vh]"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm lg:text-base 2xl:text-lg w-full font-mono pl-[20%] pr-20 subpixel-antialiased",
                        children: subtitle !== null && subtitle !== void 0 ? subtitle : ""
                    })
                }),
                entranceAnimation && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-x-0 bottom-0 top-[25vh] z-0 pointer-events-none",
                    style: {
                        background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                    },
                    children: "\xa0"
                })
            ]
        })
    });
};
/* harmony default export */ var contact_element = (ContactElement);

;// CONCATENATED MODULE: ./src/pages/contact.tsx














var Home = function() {
    var ref = (0,react.useState)(false), submitting = ref[0], setSubmitting = ref[1];
    var ref1 = (0,react.useState)(undefined), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(undefined), success = ref2[0], setSuccess = ref2[1];
    var ref3 = (0,index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.formState.errors, reset = ref3.reset;
    var onSubmit = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var _phone, payload, url;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setSubmitting(true);
                setError(undefined);
                payload = {
                    email: data.email,
                    first_name: data.first_name,
                    last_name: data.last_name,
                    phone: (_phone = data.phone) !== null && _phone !== void 0 ? _phone : "",
                    message: data.message
                };
                url = "".concat(config/* MEDUSA_BACKEND_URL */.n1, "store/contact");
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(payload)
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {
                    //console.log(data)
                    if (data.error === null || data.error.length < 1) {
                        reset({
                            email: "",
                            first_name: "",
                            last_name: "",
                            phone: "",
                            message: ""
                        });
                        setSuccess("Dankuwel voor uw bericht. We zullen zo snel mogelijk contact met u opnemen.");
                        setSubmitting(false);
                    } else setError(data.error);
                    setSubmitting(false);
                }).catch(function(error) {
                    console.error(error);
                    setError("Er is iets misgegaan. Probeer het later opnieuw.");
                    setSubmitting(false);
                });
                return [
                    2
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head/* default */.Z, {
                title: "Contact | Akupanel Store",
                description: "Neem contact met ons op voor vragen of ondersteuning. Ons team staat klaar om u te helpen bij al uw behoeften. We horen graag van u!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_element, {
                image: "https://ik.imagekit.io/ik8qpq4jb/content/6a67c255849547d462cc34dbf33db0be.png",
                alt: "Design keuken met akoestische panelen",
                caption: "",
                title: "Vragen of wilt u advies?",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-sm mb-3 renderitem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Magazijn"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Verdunplein 17",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "5627 SZ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Eindhoven, Nederland",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                children: "Let op: dit is geen bezoek adres!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Email:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:team@akupanel-store.nl",
                                children: "team@akupanel-store.nl"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Toch liever snel contact?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Start de chat rechts onderin en wij proberen u z.s.m te helpen!"
                        ]
                    })
                }),
                subtitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-xl md:text-2xl lg:text-3xl 2xl:text-4xl font-display font-base subpixel-antialiased mb-6",
                            children: "Contact"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: "w-full flex flex-col mb-10 md:mb-0",
                            onSubmit: onSubmit,
                            id: "contactform",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col w-full gap-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            label: "Voornaam"
                                        }, register("first_name", {
                                            required: "First name is required"
                                        })), {
                                            autoComplete: "given-name",
                                            errors: errors,
                                            required: true
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            label: "Achternaam"
                                        }, register("last_name", {
                                            required: "Last name is verplicht"
                                        })), {
                                            autoComplete: "family-name",
                                            errors: errors,
                                            required: true
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            label: "Email"
                                        }, register("email", {
                                            required: "Email is verplicht",
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "Ongeldig e-mailadres"
                                            }
                                        })), {
                                            autoComplete: "email",
                                            errors: errors,
                                            required: true
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            label: "Telefoonnummer"
                                        }, register("phone")), {
                                            autoComplete: "tel",
                                            errors: errors
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_textarea/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            label: "Vraag of opmerking"
                                        }, register("message", {
                                            required: "Message is verplicht"
                                        })), {
                                            errors: errors,
                                            required: true
                                        }))
                                    ]
                                }),
                                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-rose-500 w-full text-small-regular py-2 font-mono",
                                        children: "Vul alle velden correct in."
                                    })
                                }),
                                success && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-green-500 text-base-regular py-2 font-mono",
                                    children: success
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* default */.Z, {
                                    className: "mt-6",
                                    children: "Versturen"
                                })
                            ]
                        })
                    ]
                }),
                cta: {
                    text: "Vul het formulier in",
                    url: "#contactform"
                },
                entranceAnimation: true
            })
        ]
    });
};
Home.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(templates/* default */.Z, {
        children: page
    });
};
/* harmony default export */ var contact = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9128,3662,3415,1228,5445,5937,4617,6158,6556,3815,6659,2931,7092,9774,2888,179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);